import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ScreenHeader from "../../compoment/ui/ScreenHeader";
import CircleButton from "../../compoment/ui/CircleButton";
import { ArrowRight, Pencil } from "../../compoment/icon";
import { WISH_MAX } from "../../utils/wish";

/** Review screen: "Your wish is ready to fly". */
const LanternSelectedScreen = () => {
    const navigate = useNavigate();
    const [wish] = useState(() => localStorage.getItem("wish") ?? "");

    return (
        <section className="wishScreen wishScreen--review">
            <ScreenHeader />

            <main className="wishScreen__copy">
                <h1 className="wishScreen__title">
                    YOUR WISH
                    <br />
                    IS READY TO FLY
                </h1>
                <p className="wishScreen__prompt">
                    Take a moment to read your
                    <br />
                    wish before you send it.
                </p>
            </main>

            <div className="wishPreview" aria-label="Your wish">
                <p className="wishPreview__text">{wish}</p>
                <span className="wishPreview__count">
                    {wish.length}/{WISH_MAX}
                </span>
            </div>

            <button
                type="button"
                className="pillButton wishPreview__edit"
                onClick={() => navigate("/main")}
            >
                <Pencil className="pillButton__icon" />
                EDIT
            </button>

            <CircleButton
                label="NEXT"
                icon={<ArrowRight />}
                disabled={!wish.trim()}
                onClick={() => navigate("/today-joining")}
            />
        </section>
    );
};

export default LanternSelectedScreen;
